import {
  REQUEST_PAYMENT_RECEIPT,
  SET_PAYMENT_LIST,
  SET_MAIN_PAYMENT_LIST
} from './mutation-types';

import axiosInst from '@/utility/axiosInst';
  
export default {

  verifyPayment({}, payload) {
    const {id, invitationSeq, name, phoneNum, message} = payload
    return axiosInst.springAxiosInst.post(`/payment/verify/${id}/${invitationSeq}`, { name, phoneNum, message })
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        console.error("결제 검증 중 오류 발생:", err)
      })
  },

  requestPaymentReceipt({commit}, payload) {
    const {paymentId, name, phoneNum} = payload
    return axiosInst.springAxiosInst.get(`/payment/receipt/${paymentId}/${name}/${phoneNum}`)
      .then((res) => {
        commit(REQUEST_PAYMENT_RECEIPT, res.data)
        return res.data.result
      })
  },

  createUniquePaymentId({}) {
    return axiosInst.springAxiosInst.get('/payment/unique-payment-id')
      .then((res) => {
        return res.data
      })
  },

  requestPaymentListForKiosk({commit}, payload) {
    const {invitationSeq, page} = payload
    return axiosInst.springAxiosInst.get(`/payment/get-payment-list-for-kiosk/${invitationSeq}/${page}`)
      .then((res) => {
        commit(SET_PAYMENT_LIST, res.data)
        return res.data
      })
  },

  kiwoomPayment({}, payload) {
    const {invitationSeq} = payload
    return axiosInst.springAxiosInst.post(`/payment/kiwoompay/${invitationSeq}`, payload )
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        console.error("결제 검증 중 오류 발생:", err)
      })
  },  

  getMainPageList({commit}, payload) {
    const {status} = payload
    return axiosInst.springAxiosInst.get(`/payment/getMainPageList/${status}`)
      .then((res) => {
        commit(SET_MAIN_PAYMENT_LIST, res.data)
        return res.data
      }) 
      .catch((err) => {
        console.error("getMainPageList 실패:", err)
      })   
  }


}